import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
import {AIChatBox, AIChatBoxConfig} from "../../standalone/ai/AIChatBox.js";
const $ = jQuery;
export class ZIDXAccountAISuperAdmin implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountAISuperAdminContainer";
    }
    render(){
        let self=this;

    }
}